<bmcore-common-slider [tracks]="tracks"></bmcore-common-slider>
